import { render, staticRenderFns } from "./EstablishInfoModule.vue?vue&type=template&id=5def0f84&scoped=true"
import script from "./EstablishInfoModule.vue?vue&type=script&lang=js"
export * from "./EstablishInfoModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5def0f84",
  null
  
)

export default component.exports